<template>
    <div class="container vh-100">
        <div class="row align-items-center justify-content-center vh-100">
            <div class="card col-md-4 mt-5 bg-secondary text-light rounded">
                <div class="card-body">
                    <h2 class="card-title">Видеонаблюдение ГИА</h2>
                    <hr class="border border-bottom-light">
                    <h4 class="card-title">Вход в систему</h4>
                    <b-form  @submit.stop.prevent="submit()">
                        <label for="username">Имя пользователя</label>
                        <b-input v-model="username" id="username"></b-input>
                        <label for="password">Пароль</label>
                        <b-input type="password" v-model="password" id="password"></b-input>
<!--                        <b-form-checkbox class="mt-2" v-model="auto">-->
<!--                            Оставаться в системе-->
<!--                        </b-form-checkbox>-->
                        <b-form-invalid-feedback :state="!(error.length > 0)">
                            {{ error }}
                        </b-form-invalid-feedback>
                        <button type="submit" class="btn btn-primary btn-block mt-3">Вход</button>
                        <a :href="authsrv + '?returnTo=' + returnUrl" class="btn btn-primary btn-block mt-3">{{ linkText }}</a>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vuex from 'vuex'
import VueCookie from 'vue-cookie'

export default {
  name: 'LoginForm',
  data () {
    return {
      username: null,
      password: null,
      auto: false,
      error: '',
      authsrv: window.x2.authsrvUrl,
      linkText : window.x2.authsrvLinkText,
      returnUrl: window.location.origin + '/x1sso' + (this.$route.query.redirect ? '?redirect=' + this.$route.query.redirect : '')
    }
  },
  methods: {
    ...Vuex.mapActions(['login']),
    ...Vuex.mapMutations(['setToken']),
    submit () {
      this.login({ username: this.username, password: this.password })
        .then(async () => {
          if (this.auto) {
            localStorage.credentials = JSON.stringify({ username: this.username, password: this.password })
          }
          VueCookie.set('x2-auth-state', 'authorized', { expires: '24h' })
          this.setToken('authorized')
          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect)
          } else {
            this.$router.push({name: 'Main'})
          }
        })
        .catch(error => { console.log(error);  this.error = error.error.message });
    }
  }
}
</script>
